import Swiper from 'swiper';
import { debounce } from 'debounce';
class Carousel {
    constructor(container, numberSlides, swiperNext, swiperPrev, desktopCount, mobileCount, extraSettings) {
        this.swiper = null;
        this.slides = 0;
        // Best window width max values to add the swiper. This values are also in the tiles.scss.
        // 706px/16px;
        this.twoColumnsMaxmimumWidthInEms = 44.125;
        // 1023 / 16px
        this.threeColumnsMaxmimumWidthInEms = 63.9375;
        // 1376 / 16px
        this.fourColumnsMaxmimumWidthInEms = 86;
        this.addSwiper = () => {
            if (!this.swiper) {
                this.swiper = new Swiper(this.swiperContainer, Object.assign({ grabCursor: true, mousewheel: false, navigation: {
                        nextEl: this.nextElement,
                        prevEl: this.prevElement,
                    }, spaceBetween: 8, breakpoints: {
                        0: {
                            slidesPerView: this.mobileCount,
                        },
                        1023: {
                            slidesPerView: this.desktopCount,
                        },
                    } }, this.extraSettings));
            }
        };
        this.destroySwiper = () => {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        };
        this.swiperContainer = container;
        this.slides = numberSlides;
        this.nextElement = swiperNext;
        this.prevElement = swiperPrev;
        this.desktopCount = desktopCount;
        this.mobileCount = mobileCount || 2;
        this.extraSettings = extraSettings || {};
        const onWindowResize = debounce(() => {
            const widthInEms = window.innerWidth / 16;
            let showSwiper = false;
            switch (this.slides) {
                case 0:
                    showSwiper = false;
                    break;
                case 1:
                    showSwiper = false;
                    break;
                case 2:
                    if (this.twoColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                    }
                    break;
                case 3:
                    if (this.threeColumnsMaxmimumWidthInEms >= widthInEms) {
                        showSwiper = true;
                    }
                    break;
                default:
                    showSwiper = true;
            }
            if (showSwiper) {
                this.addSwiper();
            }
            else {
                this.destroySwiper();
            }
        }, 200);
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
    }
}
export default Carousel;
